import classnames from 'classnames';
import { isBoolean, isNumber, isString, uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { toRequiredLabel } from 'utils';
import HelpTooltip from '../Tooltip/HelpTooltip';
import Radio from './private/Radio';
import './RadioGroup.scss';

export default class RadioGroup extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.any,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
          isDisabled: PropTypes.bool,
          description: PropTypes.string,
          tooltipContent: PropTypes.any,
          tooltipCloseByClick: PropTypes.bool,
        }),
        PropTypes.string,
      ]),
    ).isRequired,
    name: PropTypes.string.isRequired,
    isInline: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isValid: PropTypes.bool,
    validationMessage: PropTypes.string,
    hasWrapper: PropTypes.bool,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    isHidden: PropTypes.bool,
    id: PropTypes.string,
    tooltipTitle: PropTypes.string,
    tooltipContent: PropTypes.any,
    className: PropTypes.string,
  };

  static defaultProps = {
    name: uniqueId('radio_'),
    isInline: false,
    isHidden: false,
  };

  validate() {
    const { isValid, validationMessage } = this.props;
    let message = null;

    if (validationMessage) {
      message = (
        <div className={classnames('form_error', { green: isValid, red: !isValid })}>
          {validationMessage}
        </div>
      );
    }

    return message;
  }

  formatItem(item) {
    let itemObject = item;

    if (isBoolean(item) || isString(item) || isNumber(item)) {
      itemObject = {
        value: item,
        label: item,
      };
    }

    return Object.assign({}, itemObject, {
      label: itemObject.label || itemObject.value,
    });
  }

  renderTooltip = () => {
    const { tooltipContent, tooltipTitle } = this.props;

    return tooltipContent ? (
      <div className={'RadioGroup__label-help'}>
        <HelpTooltip content={tooltipContent} title={tooltipTitle} />
      </div>
    ) : null;
  };

  renderRadioButtons() {
    const { name, items, selectedValue, onChange, isDisabled, hasWrapper } = this.props;
    return items.map((item, key) => {
      const formattedItem = this.formatItem(item);
      return (
        <Radio
          name={name}
          label={formattedItem.label}
          value={formattedItem.value}
          isDisabled={isDisabled || formattedItem.isDisabled}
          isChecked={selectedValue === formattedItem.value}
          onChange={onChange}
          description={formattedItem.description}
          hasWrapper={hasWrapper}
          tooltipContent={formattedItem.tooltipContent}
          key={key}
          tooltipHasWrap={formattedItem.hasWrapper}
          tooltipCloseByClick={formattedItem.tooltipCloseByClick}
          tooltipTitle={formattedItem.tooltipTitle}
        />
      );
    });
  }

  render() {
    const { isInline, label, isRequired, isHidden, id, className } = this.props;
    return (
      <div
        id={id}
        className={classnames('form-group', className, { 'form-group__inline': isInline })}
        hidden={isHidden}
      >
        {label ? (
          <div className="RadioGroup__label-container form_label ">
            {isRequired ? toRequiredLabel(label) : label}
            {this.renderTooltip()}
          </div>
        ) : null}
        <div className="RadioGroup__radio-buttons-container">{this.renderRadioButtons()}</div>
        {this.validate()}
      </div>
    );
  }
}
